<div *ngIf="phxShowSeparator" [class.phx-show-separator-before-tab]="phxShowSeparator && !phxHideContent"
  class="phx-tab-separator">
</div>

<ng-template #tabContent>
  <ng-content></ng-content>
</ng-template>

<a *ngIf="!isEmptyCheck(phxLink) && !phxDisableAutoSelect; else noLinkTemplate" [class.phx-tab-active]="isActive && !disabled" class="phx-tab-content-box phx-tab-container" [routerLink]="phxLink"
    [queryParamsHandling]="phxDisableQueryParamMode ? '' : 'merge'">
  <div (click)="onTabClick($event)" (cdkObserveContent)="onContentChange()" #tabBox>
    <ng-container *ngIf="!phxHideContent">
      <ng-container *ngTemplateOutlet="tabContent"></ng-container>
    </ng-container>
  </div>
</a>

<ng-template #noLinkTemplate>
  <div [class.phx-tab-active]="isActive && !disabled" (click)="onTabClick($event)" class="phx-tab-content-box phx-tab-container">
    <div (cdkObserveContent)="onContentChange()" #tabBox>
      <ng-container *ngIf="!phxHideContent">
        <span>
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </span>
      </ng-container>
  </div>
  </div>
</ng-template>
